export function useLongPress(node, { onLongPress, onClick, addCtrl }) {
    if (typeof onLongPress !== 'function')
        return console.trace('longpress is not a function');
    if (typeof onClick !== 'function')
        return console.trace('click is not a function');
    let startTime = 0;
    let timeoutId = -1;
    let ctrlPress = false;
    if (addCtrl) {
        document.addEventListener('keydown', (event) => {
            if (event.ctrlKey)
                ctrlPress = true;
        });
        document.addEventListener('keyup', (event) => {
            if (ctrlPress)
                ctrlPress = false;
        });
    }
    const millisecondHold = addCtrl ? 0 : 300;
    const mousedown = (event) => {
        if (addCtrl && !ctrlPress)
            return;
        startTime = Date.now();
        timeoutId = setTimeout(() => {
            onLongPress();
            onClick(event);
        }, millisecondHold);
    };
    const mouseup = (event) => {
        if (addCtrl && !ctrlPress)
            return onClick(event);
        if (Date.now() - startTime > millisecondHold)
            return;
        onClick(event);
        return clearInterval(timeoutId);
    };
    node.addEventListener('mousedown', mousedown);
    node.addEventListener('mouseup', mouseup);
    return {
        destroy: () => {
            node.removeEventListener('mousedown', mousedown);
            node.removeEventListener('mouseup', mouseup);
        }
    };
}
